import {
    CapacitorBarcodeScanner,
    CapacitorBarcodeScannerTypeHint
} from '@capacitor/barcode-scanner';

const SCAN_CANCELLED_ERROR_CODE = 'OS-PLUG-BARC-0006';

function isScanCancelledError(error: unknown): boolean {
    if (!(error instanceof Error)) return false;
    const code = (error as Error & { code?: string }).code;
    if (code === SCAN_CANCELLED_ERROR_CODE) return true;
    return /cancel/i.test(error.message);
}

/**
 * Launches the native QR scanner (ready-to-use UI) and returns the raw scanned
 * string, or null (cancelled / nothing scanned). Domain-agnostic.
 *
 * Both platforms use OSBarcodeLib (AVFoundation/Vision on iOS, CameraX on
 * Android) — camera permission required (Info.plist / AndroidManifest). Other
 * errors (e.g. camera access denied) propagate to the caller. Web is not handled.
 */
export async function scanQr(): Promise<string | null> {
    try {
        const { ScanResult } = await CapacitorBarcodeScanner.scanBarcode({
            hint: CapacitorBarcodeScannerTypeHint.QR_CODE
        });
        return ScanResult || null;
    } catch (error) {
        if (isScanCancelledError(error)) return null;
        throw error;
    }
}
